import $ from 'jquery';
import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { map } from 'underscore';
import { ContextualMenu } from '@fluentui/react';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getStyle } from './style';

const MetricsPicker = (props) => {
  const {
    i18n,
    classes,
    metrics,
  } = props;

  const buttonRef = useRef(null);

  const [selectedMetricIndex, setSelectedMetricIndex] = useState(0);
  const [showContextualMenu, setShowContextualMenu] = useState(false);

  const onHideContextualMenu = useCallback(() => setShowContextualMenu(false), []);

  return (
    <div className={classNames(['summary-bar-metrics-picker', 'status-dropdown', classes.container])}>
      <button
        className="dropdown-toggle"
        onClick={() => setShowContextualMenu(true)}
        ref={buttonRef}
      >
        <span className="entity-label">{i18n.getString(_TL_('Your performance'))}</span>
        <div className="entity-content">
          <div className="entity-text">
            <span>{i18n.getString(metrics[selectedMetricIndex])}</span>
            <Glyphicon
              className="icon-ChevronDown"
              glyph="ba-ChevronDown"
            />
          </div>
          {showContextualMenu && <ContextualMenu
            items={map(metrics, (metric, index) => ({
              key: metric,
              text: i18n.getString(metric),
              onClick: () => {
                $(document).trigger('qiMetricsChanged', { metric, index });
                setSelectedMetricIndex(index);
              },
            }))}
            target={buttonRef}
            onItemClick={onHideContextualMenu}
            onDismiss={onHideContextualMenu}
          />}
        </div>
      </button>
    </div>
  );
};

MetricsPicker.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
  }).isRequired,
  metrics: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export const SummaryBarMetricsPicker = withDefaultStyles(MetricsPicker, getStyle);
